<section class="w-full flex flex-col">
  <ng-container *ngFor="let item of data?.tiles">
    <jnguyen-tile-text [tile]="item.fields"></jnguyen-tile-text>
  </ng-container>
</section>
